import { ButtonToolbar, OverlayTrigger, Tooltip } from "react-bootstrap";

import { buttonTypeConstants, toastMessages } from "../../../constants";
import Button from "./Button";

const ButtonWithToolTip = (props) => {
  const {
    className,
    isDisabled = false,
    placement = "bottom",
    toolTipRootClassName,
    toolTipBody,
    //all props that are in button component are passed down
  } = props;

  const tooltip = (
    <Tooltip id="tooltip-button" className="button-with-tooltip">
      {toolTipBody}
    </Tooltip>
  );
  return toolTipBody ? (
    <ButtonToolbar className={toolTipRootClassName}>
      {/* wrapper to avoid ref issues when disabled */}
      <OverlayTrigger placement={placement} overlay={tooltip}>
        {/* don't remove w-100 and manage the width in the toolTipRootClassName prop as width is controlled at parent level (<ButtonToolbar className={toolTipRootClassName}> level) and rest of the styling is passed down*/}
        <span className="w-100">
          <Button
            {...props}
            isDisabled={isDisabled}
            className={`${className} w-100`}
          />
        </span>
      </OverlayTrigger>
    </ButtonToolbar>
  ) : (
    <Button {...props} />
  );
};

export default ButtonWithToolTip;
